var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModernTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "modern-tv-solid-rounded 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3391 4C12.5358 3.99999 13.4836 3.99998 14.2254 4.0948C14.9888 4.19238 15.6068 4.39797 16.0941 4.86124C16.5814 5.32452 16.7976 5.91197 16.9003 6.63775C17 7.34297 17 7.41073 17 8.54838V8.61825C17 9.75587 17 10.657 16.9003 11.3622C16.7976 12.088 16.5814 12.6755 16.0941 13.1388C15.6068 13.602 14.9888 13.8076 14.2254 13.9052C13.4836 14 12.5358 14 11.3391 14H8.66094C7.46427 14 6.5164 14 5.77459 13.9052C5.01116 13.8076 4.39323 13.602 3.90592 13.1388C3.41862 12.6755 3.20236 12.088 3.09972 11.3622C2.99998 10.657 2.99999 9.75593 3 8.61825V8.54841C2.99999 7.41075 2.99998 7.34298 3.09972 6.63775C3.20236 5.91197 3.41862 5.32452 3.90592 4.86124C4.39323 4.39797 5.01116 4.19238 5.77459 4.0948C6.5164 3.99998 7.46425 3.99999 8.66093 4H11.3391Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0008 16.6667C8.92623 16.6667 7.92375 16.9349 7.06372 17.3997C6.65883 17.6186 6.15321 17.4678 5.93437 17.0629C5.71554 16.658 5.86636 16.1524 6.27124 15.9336C7.37236 15.3384 8.64682 15 10.0008 15C11.3548 15 12.6292 15.3384 13.7304 15.9336C14.1352 16.1524 14.2861 16.658 14.0672 17.0629C13.8484 17.4678 13.3428 17.6186 12.9379 17.3997C12.0779 16.9349 11.0754 16.6667 10.0008 16.6667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernTv);
export default __webpack_public_path__ + "static/media/modern-tv.18400e45ebb35cacb9ecf7482cb52a54.svg";
export { ForwardRef as ReactComponent };